/**
 * Want to add more text? Go to custom/classes/calendar-text and add new properties there.
 */
export interface IAddOnsAppBaseText {
    productionListHeading: string;
    minicartTotalsLabel: string;
    skipButtonRedirectUrl: string;
    skipLabel: string;
    zoneSelectionDefault: string;
    seatedAddon: boolean;
    reserveAddOnsLabel: string;
    reserveAddOnsWithItemsLabel: string;
    synopsisToggleButtonText: string;
    performancesPanelOpenStateLabel: string;
    performancesPanelClosedStateLabel: string;
    reserveFailedErrorMessage: string;
    unseatedReserveFailedErrorMessage: string;
    seatedReserveSoldOutErrorMessage: string;
    noPriceTypeErrorMessage: string;
    noZoneErrorMessage: string;
    quantityMax: number;
    performanceProcessingMessage: string;
    configId: number;
    availablePriceTypes: string;
    cartTotal: number
    performanceUnavailableMessage: string;
    productionUnavailableMessage: string;
    priceTypeQuantityDependencies: IPriceTypeQuantityDependency[];
}

export interface IPriceTypeQuantityDependency {
    dependencyPriceType: number;
    dependentPriceType: number;
    unlockedMaximumQuantity: number;
}

export const defaultBaseText: IAddOnsAppBaseText = {
    productionListHeading: "Add Tickets",
    minicartTotalsLabel: "Current Total",
    skipButtonRedirectUrl: "/",
    skipLabel: "Skip",
    zoneSelectionDefault: "Select a zone",
    seatedAddon: false,
    reserveAddOnsLabel: "Reserve Performance",
    reserveAddOnsWithItemsLabel: "Reserve {0} Performance",
    synopsisToggleButtonText: "Read Synopsis",
    performancesPanelOpenStateLabel: "Select Performance",
    performanceUnavailableMessage: "Not available",
    productionUnavailableMessage: "No performances available",
    noPriceTypeErrorMessage: "No pricetype available",
    noZoneErrorMessage: "No zone available",
    performancesPanelClosedStateLabel: "Close",
    unseatedReserveFailedErrorMessage: "Reserve failed",
    seatedReserveSoldOutErrorMessage: "Sold Out",
    reserveFailedErrorMessage: "Failed",
    quantityMax: 6,
    performanceProcessingMessage: "Loading",
    configId: 0,
    availablePriceTypes: "",
    cartTotal: 0,
    priceTypeQuantityDependencies: []
}